/**
 * @description 库存分析-tabs单据明细表模块
 */
<template>
    <div>
        <gj-table
            ref="gjTable"
            size='has-picture'
            name="flag"
            :data="tableData"
            :columns="columns"
            :loading="loading"
            :adapt-height="false"
            :height="400"
            border="default"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
        </gj-table>
    </div>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import { DOCUMENT_DETAILS_COLUMN } from "../config.js"
import { storageAnalysisReceiptList } from "@/api/statistics";

export default {
    mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
    inject: ["getPageParams"],
    computed: {
        pageParams () {
            return this.getPageParams()
        },
    },
    data() {
        return {
            tableData: [],
            columns: DOCUMENT_DETAILS_COLUMN,
            loading: false,
        }
    },
    created() {
        this.storageAnalysisReceiptList()
    },
    methods: {
        // 获取单据明细表table数据
        async storageAnalysisReceiptList() {
            this.loading = true
            let params = {
                asinCode: this.pageParams.asinCode,
                asinType: this.pageParams.asinType,
                countryIds: this.pageParams.countryData.countryIds,
                marketIds: this.pageParams.countryData.marketIds
            }
            try {
                let res = await storageAnalysisReceiptList(params)
                this.tableData = res || []
            } catch (error) {
                console.log(error);
            }
            this.loading = false
        }
    }
};
</script>

<style scoped lang="scss">
</style>
